import configs from '@acre/config'

import { get } from '../api/search'
import { Resolvers } from '../generated/resolvers'

const { SEARCH_API_URL } = configs

const SearchResolver: Resolvers = {
  Query: {
    search: async (_parent, { q, owning_org_id, show_client, bookmark }) => {
      const params = new URLSearchParams({
        ...(show_client && { show: 'CLIENT' }),
        ...(owning_org_id && { owning_org_ids: owning_org_id }),
        ...(bookmark && { bookmark: bookmark.toString() }),
      }).toString()

      const url = `${SEARCH_API_URL}search?q=${q}${params ? `&${params}` : ''}`
      const result = await get(url, {})
      return result || null
    },
  },
}

export default SearchResolver
